// User-domain app-setting keys read by both the API and the admin apps.
export enum UserAppSettingKeyEnum {
  COLLABORATORS_COMPANY = 'COLLABORATORS_COMPANY',
}
